export const T = {
  en_GB: {
    title: "Confirm an external test?",
    body: "Record that the client passed this test outside QP. The quiz will count as passed so the flow can be submitted. Your name, the date and the reason are recorded, printed on the PDF and shown to the client in their flow, so say where and when the client passed.",
    reason: "Reason",
    reasonPlaceholder: "e.g. Client sat and passed the quiz in branch on 12 August",
    confirm: "Override",
    cancel: "Cancel",
  },
  nb_NO: {
    title: "Bekrefte ekstern test?",
    body: "Registrer at kunden har bestått denne testen utenfor QP. Quizen regnes som bestått slik at flyten kan sendes inn. Navnet ditt, datoen og begrunnelsen lagres, skrives ut på PDF-en og vises for kunden i flyten, så oppgi hvor og når kunden besto.",
    reason: "Begrunnelse",
    reasonPlaceholder: "f.eks. Kunden tok og besto quizen på kontoret 12. august",
    confirm: "Overstyr",
    cancel: "Avbryt",
  },
} as const;
